import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { StakeholderGroupListComponent } from './stakeholder-group-list/stakeholder-group-list.component'

export const stakeholderGroupRoutes: Route[] = [
  {
    path: 'stakeholder-groups',
    component: StakeholderGroupListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'stakeholder-groups/:id/edit',
    redirectTo: 'stakeholder-groups/:id',
    pathMatch: 'full'
  },
  {
    path: 'stakeholder-groups/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'StakeholderGroup',
        nameSingular: 'Stakeholder Group',
        namePlural: 'Stakeholder Groups',
        path: 'stakeholder-groups',
        slug: 'taxonomies/stakeholder-groups',
        title: 'Stakeholder Groups'
      }),
      permission: 'readTaxonomies'
    }
  }
]
